import React from "react";
import getConfig from "next/config";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

import Button from "@components/Button";
import StoreSchedule from "@components/Stores/StoreSchedule";

const StoreCard = ({ store }) => {
  const { name, address, distance, schedule, special_schedule } = store;
  const link = `${settings.baseUrl}/magazine/${store.url_key}/`;
  // const image = store.image && `${settings.cdn}/media/location/image${store.image}`;

  return (
    <article className="flex flex-col lg:block border py-4 px-3 lg:px-0 md:border-0 rounded-tr-lg rounded-bl-lg text-sm h-full">
      <h4 className="mb-2 font-medium text-xl lg:text-lg leading-26 lg:leading-23.4 -tracking-0.39">
        {name}
      </h4>

      <p className="lg:mb-3 -tracking-0.29">
        {address}

        {distance && (
          <>
            <br />
            <em>
              {`Distanta`}{" "}
              {distance < 10 ? distance.toFixed(2) : distance.toFixed(0)}km
            </em>
          </>
        )}
      </p>

      <div className="m-0 mb-3 -tracking-0.29">
        <StoreSchedule
          schedule={schedule}
          special_schedule={special_schedule}
        />
      </div>

      <div className="mt-auto button-is-block-on-mobile">
        <Button
          title={`Vezi detalii`}
          display="inline"
          displayMobile="block"
          variant="primary"
          size="normal"
          href={link}
          font="semibold"
          tracking="-tracking-0.22"
        />
      </div>

      <style>{`
        @media (max-width: 768px) {
          .button-is-block-on-mobile a {
            display: block;
          }
        }
      `}</style>
    </article>
  );
};

export default StoreCard;
